import type { DepartmentRole } from '@newfront-insurance/account-api';
import type { EmployeeAvatarType } from '@newfront-insurance/core-ui';

export enum EmployeeStatus {
  ACTIVE = 'active',
  LOCKED = 'locked',
}

/**
 * Legacy employee type from the deprecated newfront-app backend.
 * Used for mock data and backwards compatibility.
 */
export interface LegacyApiEmployee {
  id: number;
  uuid: string;
  userUuid: string;
  email: string;
  name: string;
  imageUrl: string;
  firstName: string;
  lastName: string;
  title?: string;
  team?: string;
  accountManagerSalesforceId?: string;
  producerSalesforceId?: string;
  phone?: string;
  extension?: number;
  status?: EmployeeStatus;
}

export type Employee = Pick<
  LegacyApiEmployee,
  'email' | 'firstName' | 'imageUrl' | 'lastName' | 'name' | 'title' | 'userUuid' | 'uuid'
> & {
  legacyId: number;
  extension?: number;
  phone?: string;
  type: EmployeeAvatarType;
  departments?: DepartmentRole[];
  roles?: string[];
  status?: EmployeeStatus;
};
